import { sumBy } from 'lodash';
import { isLineFullyReceived, isLineSubtotal } from './poStatusCheck.ts';

/**
 * Calculates the sum of "total" values for items in a purchase order excluding the PO line 'Subtotal'.
 *
 * @param {Array<Object>} items - The array of items in the purchase order.
 * @returns {number} - The total sum of "total" values.
 */
const sumPoItemsCost = (items) =>
  sumBy(items, (item) => {
    if (isLineSubtotal(item)) return 0;
    if (!isLineFullyReceived(item)) return 0;
    return item.total;
  });

export default sumPoItemsCost;
